import React from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../components/common/StyledToolTip";
import { ToggleRenderer } from "../../../components/dataGrid/cellRenderer";
import { trackEvent } from "../../../components/common/AppInsightsEventTracking";
import styles from "./styles";

const toggleAutoZoom = ({
  isEnabled,
  userData,
  toggleRouteAnimation,
  eventHub,
}) => {
  eventHub.emit("routeAnimation", !isEnabled);
  const userProfile = userData.userProfile;
  const eventSpecificData = {
    autoZoomEnabled: !isEnabled,
  };
  trackEvent("AutoZoom", userProfile, eventSpecificData);
  toggleRouteAnimation && toggleRouteAnimation(!isEnabled);
};
const MapAutoZoom = ({ classes, ...props }) => {
  const label = `${props.isEnabled ? "Disable" : "Enable"} Auto Zoom`;
  return (
    <Tooltip title={props.title}>
      <div
        className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${props.isMenuItem ? classes.toggleAnimationButtonMenu : ""} `}
      >
        <div className={classes.toggleText}>{label}</div>
        <ToggleRenderer
          value={props.isEnabled}
          onChange={() => toggleAutoZoom(props)}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(MapAutoZoom);
